"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import useEventStopPropagation from '../../helpers/hooks/useEventStopPropagation.mjs';
import { ActionBar } from '../DataBuilderUI/index.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';

function FieldDelete({ onClick }) {
  if (!onClick) {
    return null;
  }
  return /* @__PURE__ */ jsx(ActionBar, { children: /* @__PURE__ */ jsx(ActionBar.DeleteButton, { onClick: useEventStopPropagation(onClick), children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close }) }) });
}

export { FieldDelete };
